export default "__VITE_ASSET__B4I_w6hi__"